import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';

interface HotelBenchmarkInsightDesiredCompsetTdDeleteSignature {
  Args: {
    column: {
      trackDeleteEvent?: boolean;
      usageAnalyticsEventTrigger?: 'desired-compset' | 'compset-builder';
    };
    row: {
      deleteCompetitor: () => void;
    };
  };
}

export default class HotelBenchmarkInsightDesiredCompsetTdDelete extends Component<HotelBenchmarkInsightDesiredCompsetTdDeleteSignature> {
  @service declare usageAnalytics: Services['usage-analytics'];

  @action
  onClick(): void {
    this.args.row.deleteCompetitor();

    if (this.args.column.trackDeleteEvent) {
      this.usageAnalytics.track('Wishlist Hotel Removed', {
        eventTrigger:
          this.args.column.usageAnalyticsEventTrigger ?? 'desired-compset',
      });
    }
  }

  <template>
    <PrismButton
      @buttonType="ghost"
      @icon="bin"
      @size="small"
      data-test-id="td-delete-button"
      {{on "click" this.onClick}}
    />
  </template>
}
